module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/filetypes/office word icon-27224e99.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/filetypes/office word icon.svg
// module id = ./app/web/src/assets/filetypes/office word icon.svg
// module chunks = 0